import { Bar } from "../../components/ui/Bar";
import { formatWeight } from "../../lib/format";

/** `[bar] 12.34%` weight cell — used by both cash and position rows. */
export function WeightCell({ weight }: { weight: number }) {
	return (
		<div className="flex items-center gap-2">
			<Bar value={weight} />
			<span className="font-mono text-[11px] text-slate-300">
				{formatWeight(weight)}
			</span>
		</div>
	);
}
